/* eslint-disable import/prefer-default-export */
export const toogleScroll = (selector, scrollVisibility) => {
  // COMMENT: parametro "selector" es un string que contiene el valor a utilizar en document.querySelector
  window.document.querySelector(selector).style.overflow = scrollVisibility ? 'scroll' : 'hidden';
};
